import { render, staticRenderFns } from "./OuterCustomerManagement.vue?vue&type=template&id=e59c7b20&scoped=true"
import script from "./OuterCustomerManagement.vue?vue&type=script&lang=js"
export * from "./OuterCustomerManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e59c7b20",
  null
  
)

export default component.exports